export default __webpack_public_path__ + "media/ChevronRight.3baa43be.svg";